import initSequentialLottie from '../parts/lottie-sequence';
const SELECTOR_SECTION = '.block-benefits';
const init = () => initSequentialLottie(SELECTOR_SECTION);
document.addEventListener('DOMContentLoaded', init);
if (window.acf) {
    window.acf.addAction('render_block_preview', init);
}
export default init;
